import React from 'react';
import SupportScope from '../components/SupportScope';

const roles = [
  ['At33d', 'Incubator, cohort manager, education, ecosystem development', 'Broker, exchange, securities promoter'],
  ['Tangibl3Net', 'Asset tokenization platform, issuer workflow, compliance-file checks, token setup, recordkeeping, wallet coordination', 'Guarantor, custodian, issuer of third-party assets, public marketplace'],
  ['Business development participant', 'Strategic investor, venture participant, or capital partner supporting approved fees', 'Platform compliance approver, investment adviser to users'],
  ['Issuer', 'Legal issuer and project owner', 'Cannot claim Tangibl3Net guarantees the project'],
  ['Licensed partner / counsel', 'Legal, fiduciary, regulated issuance, securities, DASP, trustee, or tax support', 'Used when required by structure or jurisdiction'],
];

const prohibited = [
  'Guaranteed returns',
  'Risk-free',
  'Tangibl3Net-approved investment',
  'Fee-cover backing means safe',
  'Contest winner means investment-grade',
  'Guaranteed exchange listing',
  'Guaranteed liquidity',
  'Guaranteed token appreciation',
  'Tangibl3Net verified asset value',
  'Regulated by FINTRAC',
  'FINTRAC licensed',
  'Public marketplace',
  'Open secondary trading',
  'Safe investment',
];

const approved = [
  'The project is participating in the Tangibl3Net Tokenization Lab.',
  'The project has submitted its issuer file for Tangibl3Net compliance checks.',
  'The project has completed 90 days live on Tangibl3Net and may apply for eligible programs.',
  'The project received a Tangibl3Net Verified Issuer award based on documentation quality, transparency, execution, and asset-token utility.',
  'The project has been selected for business development fee-cover participation.',
];

const ProgramRulesPage = () => (
  <main className="pt-32">
    <section className="py-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="section-label mb-4">Program Rules</div>
        <h1 className="font-display text-5xl lg:text-6xl font-bold tracking-tight text-foreground">Tangibl3Net Program Rules</h1>
        <p className="mt-6 max-w-3xl text-lg text-muted-foreground leading-relaxed">
          Tangibl3Net is a platform for compliant asset tokenization. It helps verified issuers convert documented assets into controlled digital tokens with clear records, issuer workflows, and compliance guardrails.
        </p>
      </div>
    </section>

    <section className="py-16 border-t border-border bg-muted/20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <h2 className="font-display text-3xl font-bold text-foreground">Legal Perimeter</h2>
        <p className="mt-4 max-w-4xl text-muted-foreground leading-relaxed">
          Tangibl3Net does not act as an exchange, broker, dealer, investment adviser, custodian, guarantor, asset manager, trustee, or public marketplace unless separately licensed or formally appointed.
        </p>
        <p className="mt-4 max-w-4xl text-muted-foreground leading-relaxed">
          The issuer remains responsible for its legal instrument, token economics, disclosures, tax treatment, asset obligations, custody of underlying assets, redemption commitments, and regulatory compliance.
        </p>
      </div>
    </section>

    <section className="py-16 border-t border-border">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <h2 className="font-display text-3xl font-bold text-foreground">Entity Role Table</h2>
        <div className="mt-6 overflow-hidden rounded-xl border border-border bg-card">
          <div className="grid lg:grid-cols-3 bg-muted/50 text-xs uppercase tracking-wider text-muted-foreground">
            <div className="p-4 border-r border-border">Entity</div>
            <div className="p-4 border-r border-border">Role</div>
            <div className="p-4">Not its role unless separately licensed</div>
          </div>
          {roles.map(([entity, role, notRole]) => (
            <div key={entity} className="grid lg:grid-cols-3 border-t border-border">
              <div className="p-4 font-semibold text-foreground border-r border-border">{entity}</div>
              <div className="p-4 text-muted-foreground border-r border-border">{role}</div>
              <div className="p-4 text-muted-foreground">{notRole}</div>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section id="contest" className="py-16 border-t border-border">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <h2 className="font-display text-3xl font-bold text-foreground">Quarterly Verified Issuer Contest</h2>
        <p className="mt-4 max-w-4xl text-muted-foreground leading-relaxed">
          Tangibl3Net awards $10,000 quarterly to eligible tokenization projects based on documentation quality, transparency, compliance discipline, execution, treasury discipline, and asset-token utility.
        </p>
        <p className="mt-4 max-w-4xl text-muted-foreground leading-relaxed">
          The contest does not reward token price, trading volume, market capitalization, hype, or exchange listings. Eligibility requires at least 90 days live on Tangibl3Net with Verified File — Active status.
        </p>
        <p className="mt-4 max-w-4xl text-muted-foreground leading-relaxed">
          Winning means the project scored well under Tangibl3Net&apos;s contest criteria. It does not mean the token will rise in value, become liquid, be listed on an exchange, or qualify as a safe investment.
        </p>
      </div>
    </section>

    <SupportScope />

    <section className="py-16 border-t border-border bg-muted/20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-2 gap-8">
        <div className="rounded-2xl border border-border bg-card p-6">
          <h2 className="font-display text-2xl font-bold text-foreground">Prohibited language</h2>
          <div className="mt-5 grid gap-2">
            {prohibited.map((item) => <div key={item} className="text-sm text-muted-foreground">• {item}</div>)}
          </div>
        </div>
        <div className="rounded-2xl border border-border bg-card p-6">
          <h2 className="font-display text-2xl font-bold text-foreground">Approved language</h2>
          <div className="mt-5 grid gap-2">
            {approved.map((item) => <div key={item} className="text-sm text-muted-foreground">• {item}</div>)}
          </div>
        </div>
      </div>
    </section>
  </main>
);

export default ProgramRulesPage;
